import { render, staticRenderFns } from "./AreaMonitorada.vue?vue&type=template&id=ecb42c8e&scoped=true&lang=pug"
import script from "./AreaMonitorada.vue?vue&type=script&lang=js"
export * from "./AreaMonitorada.vue?vue&type=script&lang=js"
import style0 from "./AreaMonitorada.vue?vue&type=style&index=0&id=ecb42c8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb42c8e",
  null
  
)

export default component.exports